export default {
  settings_title: "Settings",
  settings_description: "View the",
  settings_missing_inspection_rules_report: "Missing Inspection Rules report",
  settings_create_edit_rules: "to create and edit new rules for your assets.",
  settings_saved: "Settings saved successfully",
  settings_default_asset_type: "Default asset type for EVIR Mobile",
  settings_default_asset_type_desc: "Please choose which asset type should be the default for all future inspections.",
  settings_inspection_image_retention: "Inspection and image retention",
  settings_retention_desc: "Amount of time inspections and images will be kept on file.",
  settings_retain_for_number_of_years: "Retain for number of years",
  settings_save: "Save Settings",
  settings_undo: "Undo",
  settings_saving: "Saving...",
};
